import React from 'react';
import Header from '../../../components/User/Header';
import { Grid, Box } from '@material-ui/core';
import useStyles from './IFrameDocumentContainer.styles';

export default function IFrameDocumentContainer({
  url,
  title
}: {
  url: string;
  title: string;
}) {
  return (
    <>
      <Header />
      <div className={useStyles().container}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{ height: '100%' }}
        >
          <Box height="100%" maxWidth="900px" width="100%">
            <iframe
              src={url}
              title={title}
              width="100%"
              height="100%"
              style={{ border: 'none' }}
            />
          </Box>
        </Grid>
      </div>
    </>
  );
}
